import axios from "axios";
const clientId = process.env.REACT_APP_CLIENT_ID;
const baseURL = process.env.REACT_APP_API_URL;
const api = axios.create({
  baseURL,
  headers: { "X-Cotribute-Client-Id": clientId },
});

// Authenticated portal routes are nested under /organization/{slug}, so the
// tenant is recoverable from the path. Sending it on every request keeps tenant
// scope a property of the client rather than of individual call sites.
const getOrganizationSlug = (): string | undefined => {
  const [, route, slug] = window.location.pathname.split("/");
  // Only /organization/{slug} carries a tenant. Other routes (404, and anything
  // added later) would otherwise send an unrelated path segment as the tenant.
  // React Router matches paths case-insensitively, so /Organization/acme loads
  // the app and must be recognised here too.
  if (route?.toLowerCase() !== "organization" || !slug) {
    return undefined;
  }
  // pathname is percent-encoded; useParams() is not. Decode so the header agrees
  // with the organization the app actually loaded.
  try {
    return decodeURIComponent(slug);
  } catch {
    // Malformed escape sequence -- send nothing rather than a wrong tenant.
    return undefined;
  }
};

api.interceptors.request.use((config) => {
  const organizationSlug = getOrganizationSlug();
  if (organizationSlug) {
    config.headers["X-Cotribute-Organization-Slug"] = organizationSlug;
  }
  return config;
});

let authToken: string, refreshToken: string;

export interface Token {
  auth: string;
  refresh: string;
}

export function setTokens(token: Token) {
  authToken = token.auth;
  refreshToken = token.refresh;
  api.defaults.headers["Authorization"] = `Bearer ${authToken}`;
}

export function getCurrentTokens() {
  return { refreshToken, authToken };
}

export function clearTokens() {
  authToken = "";
  refreshToken = "";
  delete api.defaults.headers["Authorization"];
}

export default api;
